import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  combineCheckInBaggagePolicies,
  createMockData,
  createMockDataWithResponse,
} from '@dapi/sdk/spec';
import {
  acceptedJourney,
  checkInBaggagePoliciesWithNoFreeBagAllowance,
  journeys,
  seatmap,
} from '../../mock/data';

/**
 * OW 1Journey
 * 1ADT
 * Display baggage page
 */
export const ow1Journey1AdtBaggagePage: MockMap = {
  getBaggagePoliciesFromJourney: [
    createMockData(combineCheckInBaggagePolicies([checkInBaggagePoliciesWithNoFreeBagAllowance]).items),
    createMockData(combineCheckInBaggagePolicies([checkInBaggagePoliciesWithNoFreeBagAllowance]).items)
  ],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([])],
  retrieveJourneys: [
    createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse([acceptedJourney], 201)
  ],
  retrieveJourney: [
    createMockData(acceptedJourney)
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)]
};
